import React from 'react'
import { TableProps } from 'antd/lib/table'
import moment from 'moment'
import { ColumnProps } from 'src/components/Ant/Table'
import { R9Data } from 'src/store/ducks/reports/types'
import { Table, Text } from 'src/components/Ant'
import Tooltip from 'antd/lib/tooltip'

const columns: ColumnProps<R9Data>[] = [
  {
    align: 'center',
    dataIndex: 'created_on',
    key: 'created_on',
    render: (value: number) => (
      <Text>
        {moment
          .unix(value)
          .utc()
          .format('DD/MM/YYYY')}
      </Text>
    ),
    title: 'web.report.9.data.created-on',
    width: 70
  },
  {
    align: 'center',
    dataIndex: 'rate',
    key: 'rate',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.9.data.rate',
    width: 50
  },
  {
    align: 'left',
    dataIndex: 'message',
    ellipsis: true,
    key: 'message',
    render: (value: string) => <Tooltip title={value}>{value}</Tooltip>,
    title: 'web.report.9.data.message'
  }
]

function TableDetail(props: TableProps<R9Data>) {
  return (
    <Table
      {...props}
      className="table-striped table-sm"
      columns={columns}
      pagination={false}
    />
  )
}

export default TableDetail
